module.exports = __webpack_public_path__ + "assets/img/icon-wechat-mnp.15304a7c.png";